export default "__VITE_ASSET__DL2lrtj1__"